import { Navigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../lib/UserAuthContext";

export default function UserProtected({ children }) {
  const { user, checking } = useUserAuth();
  const loc = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="user-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}
